import { connect } from 'react-redux'
import SucursalView from './PageBranches.component'
import * as urls from '../../constants/api'
import { retrivePropertyTypes, retriveOperationTypes, saveOriginOffice } from '../../actions/searchBar'
import { loadDirectorsBySector,
  loadBrokersBySector,
  loadSubsidiaryTypes,
  loadNewsBySector,
  loadImisBySector,
  loadRelevantProperties } from '../../actions/subsidiaries'
import { setPhone } from '../../actions/header'

const mapStateToProps = (state) => {
  return {
    subsidiaries: state.subsidiaries.list,
    directors: state.subsidiaries.directors,
    brokers: state.subsidiaries.brokers,
    news: state.subsidiaries.news,
    imis: state.subsidiaries.imis,
    centro: state.subsidiaries.centro,
    nordelta: state.subsidiaries.nordelta,
    sanisidro: state.subsidiaries.sanisidro,
    puertos: state.subsidiaries.puertos,
    palermo: state.subsidiaries.palermo,
    pilar: state.subsidiaries.pilar,
    escobar: state.subsidiaries.escobar,
    services: state.app.sectors,
    offices: state.subsidiaries.list.filter(e=>e.menu_order>0).sort((a, b)=>Math.sign(a.menu_order - b.menu_order)),
    originPath: state.searchBar.originPath,
    originOffice: state.searchBar.originOffice,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    didMount: () => {
      dispatch(loadSubsidiaryTypes())
      dispatch(retrivePropertyTypes(urls.RESIDENTIAL))
      dispatch(loadRelevantProperties()),
      dispatch(loadDirectorsBySector(6)),
      dispatch(loadBrokersBySector(6)),
      dispatch(loadNewsBySector(6)),
      dispatch(loadImisBySector(6))
    },
    loadMoreOperationTypes: value => dispatch((retriveOperationTypes(value))),
    onSelectOffice: value => dispatch(saveOriginOffice(value)),
    setPhone: value => dispatch(setPhone(value))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SucursalView)



// WEBPACK FOOTER //
// ./src/features/PageBranches/PageBranches.container.js